import { t } from "i18next";
import { Table } from "@sentara-health/optimahealth_web";
import SearchListItem from "./SearchListItem";
import { MemberList, SelectedDepType } from "utils/models/CommonTypes";

// NB: Need to make these exportable in ui library
type TableCell = {
  text: any;
  colspan?: number;
  rowspan?: number;
  tableStyle?: React.CSSProperties;
};

type TableRow = TableCell[];

type Props = {
  pageList?: MemberList;
  page: number;
  selectedDep?: SelectedDepType;
  setSelectedDep: (v: SelectedDepType) => void;
};

const SearchTableDeskTop = ({
  pageList,
  selectedDep,
  page,
  setSelectedDep,
}: Props) => {
  const tableHeader: TableRow = [
    {
      text: t("payMonthlyInvoice.select"),
      tableStyle: { textAlign: "center" },
    },
    { text: t("enrollmentHistoryForm.memberId") },
    { text: t("enrollmentHistoryForm.groupId") },
    { text: t("enrollmentHistoryForm.name") },
    { text: t("enrollmentHistoryForm.relationship") },
  ];

  const noResultsRow: TableRow = [
    { text: t("noResult"), colspan: 5, tableStyle: { textAlign: "center" } },
  ];

  return (
    <div className="table-responsive">
      <Table
        header={tableHeader}
        rowsChildren={
          pageList ? (
            <SearchListItem
              {...{
                pageList,
                selectedDep,
                page,
                setSelectedDep,
              }}
            />
          ) : (
            <tr>
              {noResultsRow.map((cell, index) => (
                <td key={index} colSpan={cell.colspan} style={cell.tableStyle}>
                  {cell.text}
                </td>
              ))}
            </tr>
          )
        }
        className="table table-custom-style align-middle"
        data-testid="tblRequestMemberIdCardSearchResults"
        noDataFound={t("noResult")}
      />
    </div>
  );
};

export default SearchTableDeskTop;
